export const ProductCategoriesEnums = {
  iPhone: "iPhone",
  iPad: "iPad",
  watch: "Watch",
  airpods: "AirPods",
  airtag: "AirTag",
  accessories: "Phụ kiện",
};

export const ProductLabelsEnums = {
  bestSeller: "Bán chạy",
  newArrival: "Hàng mới",
  featured: "Nổi bật",
};
